import{jsx as r}from"react/jsx-runtime";import{styled as e}from"styled-components";import{MessageList as t}from"../styles/style.mjs";const i=e.li`
  margin-left: 20px;
  color: #222222;
  list-style: url('images/check_mark_16x16.png');
  white-space: pre-wrap;
`;function n({info:e}){return r(t,{className:"info",children:e.map(((e,t)=>r(i,{children:r("span",{children:e})},t)))})}export{n as InfoList};
